import React from 'react';
import {
  ColumnContainer,
  Heading,
  LoginBackImage,
  LoginContainer,
  LoginWrapper,
  Logo,
  LogoWrap,
  PartialWrapLoginBackImage,
  Wrap,
} from 'pages/login/login_style';
import { useSelector } from 'react-redux';
import ChangePasswordComponent from 'component/login_components/changePassword';

const ChangePasswordPage = () => {
  const { defaultTheme } = useSelector((state) => state.themes);

  return (
    <div className='body-content'>
      {defaultTheme === 'globlue' ? (
        <LoginBackImage className='changePassword-background-image'>
          <ColumnContainer className='globlue changePassword-column-container'>
            <div className='column' />
            <div className='column'>
              <Wrap className='changePassword-wrapper'>
                <LoginContainer className='changePassword-container'>
                  <LogoWrap className='changePassword-logo-wrap'>
                    <Logo alt='Logo' className='changePassword-logo' />
                  </LogoWrap>
                  <Heading className={`${defaultTheme} changePassword-heading`}>Change Password</Heading>
                  <ChangePasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </Wrap>
            </div>
          </ColumnContainer>
        </LoginBackImage>
      ) : defaultTheme === 'mornglow' ? (
        <PartialWrapLoginBackImage className='mornglow changePassword-partial-wrapper'>
          <ColumnContainer className='mornglow changePassword-column-container'>
            <div className='column'>
              <Wrap className='logoleft changePassword-wrapper'>
                <Logo className='leftsideLogo changePassword-logo' alt='Logo' />
                <LoginWrapper className={`${defaultTheme} changePassword-inside-wrap`}>
                  <LoginContainer className='changePassword-container'>
                    <Heading className={`${defaultTheme} changePassword-heading`}>Change Password</Heading>
                    <ChangePasswordComponent theme={defaultTheme} />
                  </LoginContainer>
                </LoginWrapper>
              </Wrap>
            </div>
          </ColumnContainer>
          <LoginBackImage className='changePassword-background-image'></LoginBackImage>
        </PartialWrapLoginBackImage>
      ) : defaultTheme === 'nitrate' ? (
        <LoginBackImage className='changePassword-background-image'>
          <ColumnContainer className='nitrate changePassword-column-container'>
            <Wrap className='changePassword-wrapper'>
              <LoginWrapper className={`${defaultTheme} changePassword-inside-wrap`}>
                <LoginContainer className='changePassword-container'>
                  <LogoWrap className='changePassword-logo-wrap'>
                    <Logo alt='Logo' className='changePassword-logo' />
                  </LogoWrap>
                  <Heading className={`${defaultTheme} changePassword-heading`}>Change Password</Heading>
                  <ChangePasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </LoginWrapper>
            </Wrap>
          </ColumnContainer>
        </LoginBackImage>
      ) : defaultTheme === 'teamring' ? (
        <PartialWrapLoginBackImage className='changePassword-partial-wrapper'>
          <LoginBackImage className='changePassword-background-image'>
            <Wrap className='logoleft changePassword-wrapper'>
              <Logo className='leftsideLogo changePassword-logo' alt='Logo' />
            </Wrap>
          </LoginBackImage>
          <ColumnContainer className='teamring changePassword-column-container'>
            <Wrap className='changePassword-wrapper-second'>
              <LoginWrapper className={`${defaultTheme} changePassword-inside-wrap`}>
                <LoginContainer className='changePassword-container'>
                  <Heading className={`${defaultTheme} changePassword-heading`}>Change Password</Heading>
                  <ChangePasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </LoginWrapper>
            </Wrap>
          </ColumnContainer>
        </PartialWrapLoginBackImage>
      ) : (
        ''
      )}
    </div>
  );
};

export default ChangePasswordPage;
